import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import MenuBar from "../components/MenuBar/MenuBar";

const PublicLayout = () => {
  return (
    <div className="publiclayout">
      <Navbar />
      <MenuBar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default PublicLayout;
